import './OnboardingSteps.scss';
import React from 'react';
import { Steps } from 'antd';
export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["Connect"] = "Connect";
    OnboardingStep["Team"] = "Team";
    OnboardingStep["Failed"] = "Failed";
})(OnboardingStep || (OnboardingStep = {}));
const flow = [OnboardingStep.Connect, OnboardingStep.Team];
export const OnboardingSteps = ({ currentStep }) => React.createElement("div", { className: 'onboarding-steps' },
    React.createElement(Steps, { current: flow.indexOf(currentStep), items: flow.map((step) => ({ title: step })) }));
